// extracted by css-extract-rspack-plugin
export default {"StaticDiffPreview":"StaticUnifiedDiffPreview-module__StaticDiffPreview__dZfZXRH","HeaderContainer":"StaticUnifiedDiffPreview-module__HeaderContainer__Y7SRj3J"};